import { Trans } from '@lingui/react/macro';

import IconCegid from '@/icons/Cegid.svg';
import { IconProps } from '@/icons/IconWrapper';
import IconStripe from '@/icons/Stripe.svg';
import { TransactionFromGetMany } from '@/models/transaction';

/* eslint-disable lingui/no-unlocalized-strings */
const connectors = {
  stripe: 'Stripe',
  cegid: 'Cegid',
  mock: 'Mock',
  nepting: 'Nepting',
};
/* eslint-enable lingui/no-unlocalized-strings */

const methods = {
  online: <Trans id="transaction.connector.online">Online</Trans>,
  'point-of-sales': <Trans id="transaction.connector.point-of-sales">POS</Trans>,
  external: <Trans id="transaction.connector.external">External</Trans>,
  reconciliation: <Trans id="transaction.connector.reconciliation">Reconciliation</Trans>,
};

export const TransactionMethod = ({
  transaction,
}: {
  transaction: {
    method: TransactionFromGetMany['method'];
    connector: TransactionFromGetMany['connector'];
  };
}) => {
  if (transaction.connector) {
    return connectors[transaction.connector];
  }

  if (transaction.method) {
    return methods[transaction.method];
  }

  return <Trans id="transaction.connector.unknown">Unknown</Trans>;
};

export const TransactionMethodIcon = ({
  transaction,
  ...props
}: {
  transaction: {
    connector?: TransactionFromGetMany['connector'];
  };
} & IconProps) => {
  if (transaction.connector === 'stripe') {
    return <IconStripe {...props} />;
  }

  if (transaction.connector === 'cegid') {
    return <IconCegid {...props} />;
  }

  return null;
};
